import { Footer } from '@/previewThemes/tools_machine/Footer';
import { Header } from '@/previewThemes/tools_machine/Header';
import { Product } from '@/previewThemes/tools_machine/Product';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  listing: {
    // Four across beside the filter rail, which is what the widest page column
    // in the set buys: a trade catalogue is compared by specification, and a
    // shopper choosing between eleven impact drivers wants them on one screen.
    grid: 'grid-cols-2 gap-5 lg:grid-cols-3 xl:grid-cols-4',
    // A hardware shop is filtered by brand, voltage, chuck size and price all
    // at once, and a row of chips cannot hold four axes of that.
    filters: 'sidebar',
    columns: 4,
    // Every tile in this theme is a bordered box - see the square corners in
    // `meta.ts`. The framed card is that box.
    card: 'framed',
  },
  // Outlined, never filled: this theme separates with a rule and reserves its
  // fills for the three bands that are meant to shout.
  cart: { grid: 'mt-8 grid gap-8 lg:grid-cols-3', panel: 'outlined' },
  checkout: {
    grid: 'mt-8 grid items-start gap-8 lg:grid-cols-[minmax(0,1fr)_24rem]',
    panel: 'outlined',
  },
  search: {
    grid: 'mt-8 grid gap-8 lg:grid-cols-[260px_1fr]',
    results: 'grid grid-cols-2 gap-5 lg:grid-cols-3 xl:grid-cols-4',
    columns: 4,
    card: 'framed',
    panel: 'outlined',
  },
  blog: { list: 'grid gap-6 sm:grid-cols-2 lg:grid-cols-3', title: 'text-lg' },
  // Six across: the department index of a shop with this many of them is a
  // lineup to scan, not a set of feature cards to read.
  category: { grid: 'grid gap-5 sm:grid-cols-3 lg:grid-cols-6', tile: 'card' },
  // What this theme used to write on `BuyBox` and `ProductGallery` by hand.
  // The merchant's components read it wherever they have left a setting at
  // "the theme's own", which is where every shop starts - so a shop nobody
  // has arranged renders the product page this theme has always drawn.
  parts: {
    product_details: {
      presentation: {
        classes: { product_title: 'text-3xl sm:text-[2.5rem]' },
        wideButtons: true,
        gallery: { thumbs: 'rail', rounded: false },
      },
    },
  },
};
